import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function OneOfReasonUITooltip({
  oneOf,
  placement,
  disabled: _disabled = false,
  title: _title = '',
  children
}) {
  const reason = oneOf.find(({
    showWhen,
    title
  }) => showWhen ? title : null);
  if (!reason) {
    return /*#__PURE__*/_jsx(Tooltip, {
      disabled: true,
      children: children
    });
  }
  return /*#__PURE__*/_jsx(Tooltip, {
    placement: placement,
    disabled: _disabled,
    title: /*#__PURE__*/_jsxs(_Fragment, {
      children: [_title && /*#__PURE__*/_jsxs(_Fragment, {
        children: [_title, /*#__PURE__*/_jsx("br", {})]
      }), reason.title]
    }),
    children: children
  });
}
export default OneOfReasonUITooltip;